export default class ElementActionsManager {
  static PASTE_OFFSET = 30;

  constructor(selectionManager, dragManager, elementMap) {
    this.selectionManager = selectionManager;
    this.dragManager = dragManager;
    this.elementMap = elementMap;
    this.clipboard = [];
  }

  deleteSelected() {
    const elements = this.selectionManager.getSelectedElements();

    if (elements.length > 0) {
      this.selectionManager.deselectAll();
      elements.forEach(element => {
        element.remove();
      });
    }
  }

  handleSelectionAndDrag(event, element) {
    const selection = this.selectionManager;
    const isAlreadySelected = selection.isSelected(element);

    if (event.shiftKey && isAlreadySelected) {
      selection.deselectElement(element);
      return;
    }

    if (isAlreadySelected && selection.hasMultipleSelected()) {
      this.dragManager.startDrag(event, element, selection.getSelectedElements());
    } else {
      selection.selectElement(element, event.shiftKey);
      this.dragManager.startDrag(event, element, selection.getSelectedElements());
    }
  }

  copySelected() {
    const elements = this.selectionManager.getSelectedElements();

    if (elements.length === 0) return 0;

    this.clipboard = elements.map(domElement => {
      const instance = this.elementMap.getInstance(domElement);
      return instance.serialize();
    });

    return this.clipboard.length;
  }

  pasteElements(createElementCallback) {
    if (this.clipboard.length === 0) return [];

    const pastedElements = this.clipboard.map(data => {
      const clonedData = JSON.parse(JSON.stringify(data));
      const left = parseInt(clonedData.left.replace('px', '')) + ElementActionsManager.PASTE_OFFSET;
      const top = parseInt(clonedData.top.replace('px', '')) + ElementActionsManager.PASTE_OFFSET;
      clonedData.left = `${left}px`;
      clonedData.top = `${top}px`;

      return createElementCallback(clonedData);
    });

    return pastedElements;
  }
}
